module.exports = __webpack_public_path__ + "img/cover-slot-bg.8d5936b8.jpg";